module.exports = __webpack_public_path__ + "img/20190923172528360截图20190923163238107.fd88b5e6.jpg";